export const module = {
  info: {
    name: 'voip-vos-server',
    caption: 'voip vos server'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    caption: 'VOS Servers',
    icon: 'el-icon-cpu',
    routeName: 'module->voip-vos-server->create',
    children: [
      {
        caption: 'Create VOS Server',
        icon: 'el-icon-plus',
        routeName: 'module->voip-vos-server->create'
      },
      {
        caption: 'List VOS Servers',
        icon: 'el-icon-more-outline',
        routeName: 'module->voip-vos-server->list->page',
        routeParams: { listPage: 1}
      }
    ]
  }
}

export default module
